// extracted by mini-css-extract-plugin
export default {"add_friend_btn":"AddFriendButton_add_friend_btn__ZwAwd"};